module.exports = __webpack_public_path__ + "WashUMed-3d5caa248f61f97b08e1989655844768.png";